package com.vamvisions.main.portfolio.domain.model

/** A date known to the year, or to the year and [month] (1-12). */
data class PartialDate(val year: Int, val month: Int? = null)
